
import { PropType } from '@nuxtjs/composition-api'
// @ts-expect-error
import { SwiperOptions } from 'swiper/types'
import { useSwiper } from '~/composables/useSwiper'

import ProductImage from '~/components/molecules/ProductImage.vue'

export default {
  name: 'ThumbsSlider',
  components: {
    ProductImage
  },
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    images: {
      type: Array,
      default: () => []
    },
    swiperOptions: {
      type: Object as PropType<SwiperOptions>,
      default: () => ({
        spaceBetween: 16,
        slidesPerView: 'auto',
        grabCursor: true,
        freeMode: true
      } as SwiperOptions)
    }
  },
  setup () {
    const { setInstance, changeSlide } = useSwiper()

    return {
      setInstance,
      changeSlide
    }
  }
}
